<div class="home">
  <div class="htv-page-content" [innerHTML]="pageHtml"></div>
  <app-nav-bar
    [menus]="menus"
    [resolution]="currentResolution"
    (buttonClicked)="onNavButtonClick($event)"></app-nav-bar>
</div>
